import ActionType from '../ActionType'
import { Auth } from 'utils/Auth'
import API_URL from 'utils/ApiUrl'
import AJV from 'ajv'
import { groupsByID2 as groupsByID } from 'selectors'
// import ajvErrors from 'ajv-errors'

const service = 'signupform'

export const addOrUpdateForm = (id) => (dispatch, getState) => {
  const addOrEdit = getState().signupForm.addOrEdit

  const body = {
    name: addOrEdit.values.formName.value,
    title: {
      color: addOrEdit.values.titleTextColor.value,
      text: addOrEdit.values.title.value,
    },
    description: {
      color: addOrEdit.values.descriptionTextColor.value,
      text: addOrEdit.values.description.value,
    },
    display_type: addOrEdit.values.embedType.value,
    contact_fields: Object.keys(addOrEdit.fields)
      .sort((a, b) => addOrEdit.fields[a].idx - addOrEdit.fields[b].idx)
      .map((key) => ({
        field_name: key,
        required: addOrEdit.fields[key].required,
      })),
    contactgroup_ids: addOrEdit.groupSelect.value.map(
      (groupOption) => groupOption.groupID,
    ),
    button: {
      text: addOrEdit.values.buttonText.value,
      text_color: addOrEdit.values.buttonTextColor.value,
      background_color: addOrEdit.values.buttonBackgroundColor.value,
    },
    background_color: addOrEdit.values.backgroundColor.value,
    text_color: addOrEdit.values.textColor.value,
    font: addOrEdit.values.font.value,
  }

  if (addOrEdit.values.logoURL.value) {
    body.logo_url = addOrEdit.values.logoURL.value
  }

  return Promise.resolve(
    dispatch(
      id === 'new' ? postSignupForm(body) : putSignupForm({ ...body, id }),
    ),
  )
}

export const postSignupForm = (body) => (dispatch, getState) => {
  dispatch({ type: ActionType.SignupForm.ADD_REQUEST })
  const schema = getState().signupForm.schema.POST

  const postHelper = (schema) => {
    const ajv = new AJV({ verbose: true, allErrors: true, jsonPointers: true })
    // ajvErrors(ajv)

    const valid = ajv
      .addSchema(schema, 'postFormSchema')
      .validate('postFormSchema', body)

    if (!valid) {
      dispatch({
        type: ActionType.SignupForm.VALIDATION_FAILURE,
        payload: valid,
        errors: ajv.errors,
        errorsText: ajv.errorsText(),
      })
      return valid
    }

    return Auth.currentSession()
      .then((session) => {
        dispatch({ type: ActionType.SignupForm.VALIDATION_SUCCESS })
        const headerValue = `Bearer ${session.idToken.jwtToken}`
        return fetch(`${API_URL}/${service}`, {
          body: JSON.stringify(body), // must match 'Content-Type' header
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then((res) => res.json().then(data => { if (!res.ok) { return { notOk: true, ...data } } return data }))
          .then(
            (payload) => {
              if (
                  
                payload && payload.notOk
              ) {
                dispatch({
                  type: ActionType.Data.CREATE_FAILURE,
                  payload,
                  entityType: 'signupform',
                  notOk: true,
                })
                return
              }

              dispatch({
                type: ActionType.SignupForm.ADD_SUCCESS,
                payload,
              })
              return payload
            },
            (error) => {
              dispatch({
                type: ActionType.Data.CREATE_FAILURE,
                payload: error,
                entityType: 'signupform',
                notOk: true,
              })
              return false
            },
          )
      })
      .catch((err) => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  }
  if (schema) {
    return postHelper(schema)
  } else {
    return dispatch(getSignupFormSchema('POST')).then((schema) =>
      postHelper(schema),
    )
  }
}

export const putSignupForm = (body) => (dispatch, getState) => {
  dispatch({ type: ActionType.SignupForm.UPDATE_REQUEST })
  const schema = getState().signupForm.schema.PUT

  const putHelper = (schema) => {
    var ajv = new AJV({ allErrors: true, jsonPointers: true })
    var valid = ajv
      .addSchema(schema, 'putFormSchema')
      .validate('putFormSchema', body)

    if (!valid) {
      dispatch({
        type: ActionType.SignupForm.VALIDATION_FAILURE,
        payload: valid,
        errors: ajv.errors,
        errorsText: ajv.errorsText(),
      })
      return valid
    }

    return Auth.currentSession()
      .then((session) => {
        dispatch({ type: ActionType.SignupForm.VALIDATION_SUCCESS })
        const headerValue = `Bearer ${session.idToken.jwtToken}`
        return fetch(`${API_URL}/${service}/${body.id}`, {
          body: JSON.stringify(body), // must match 'Content-Type' header
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'PUT', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then((res) => res.json().then(data => { if (!res.ok) { return { notOk: true, ...data } } return data }))
          .then(
            (payload) => {
              if (
                  
                payload && payload.notOk
              ) {
                dispatch({
                  type: ActionType.Data.UPDATE_FAILURE,
                  payload,
                  entityType: 'signupform',
                  notOk: true,
                })
                return
              }

              dispatch({
                type: ActionType.SignupForm.UPDATE_SUCCESS,
                payload,
              })
              return payload
            },
            (error) => {
              dispatch({
                type: ActionType.Data.UPDATE_FAILURE,
                payload: error,
                entityType: 'signupform',
              })
              return false
            },
          )
      })
      .catch((err) => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  }
  if (schema) {
    return putHelper(schema)
  } else {
    return dispatch(getSignupFormSchema('PUT')).then((schema) =>
      putHelper(schema),
    )
  }
}

export const listSignupForm = () => (dispatch, getState) => {
  dispatch({ type: ActionType.SignupForm.LIST_REQUEST })

  return Auth.currentSession()
    .then((session) => {
      const headerValue = `Bearer ${session.idToken.jwtToken}`

      return fetch(`${API_URL}/${service}`, {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'content-type': 'application/json',
          authorization: headerValue,
        },
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then((res) => res.json().then(data => { if (!res.ok) { return { notOk: true, ...data } } return data }))
        .then(
          (payload) =>
               payload && payload.notOk
              ? dispatch({
                  type: ActionType.Data.LIST_FAILURE,
                  entityType: 'signupform',
                  notOk: true,
                  payload,
                })
              : dispatch({
                  type: ActionType.SignupForm.LIST_SUCCESS,
                  payload,
                }),
          (error) =>
            dispatch({
              type: ActionType.Data.LIST_FAILURE,
              entityType: 'signupform',
              payload: error,
            }),
        )
    })
    .catch((err) => {
      console.log(err)
      if (err.code === 'UserNotFoundException') {
        window.localStorage.clear()
        window.location.reload(true)
      }
    })
}

export const readSignupForm = (id) => (dispatch, getState) => {
  dispatch({ type: ActionType.SignupForm.READ_REQUEST })

  return Auth.currentSession()
    .then((session) => {
      const headerValue = `Bearer ${session.idToken.jwtToken}`

      return fetch(`${API_URL}/${service}/${id}`, {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'content-type': 'application/json',
          authorization: headerValue,
        },
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then((res) => res.json().then(data => { if (!res.ok) { return { notOk: true, ...data } } return data }))
        .then(
          (payload) => {
            if (   payload && payload.notOk) {
              dispatch({
                type: ActionType.Data.READ_FAILURE,
                payload,
                entityType: 'signupform',
                notOk: true,
              })
              return
            }

            dispatch({
              type: ActionType.SignupForm.READ_SUCCESS,
              payload,
            })
            return payload
          },
          (error) =>
            dispatch({
              type: ActionType.Data.READ_FAILURE,
              payload: error,
              entityType: 'signupform',
              notOk: true,
            }),
        )
    })
    .catch((err) => {
      console.log(err)
      if (err.code === 'UserNotFoundException') {
        window.localStorage.clear()
        window.location.reload(true)
      }
    })
}

export const deleteSignupForm = (id) => (dispatch, getState) => {
  dispatch({ type: ActionType.SignupForm.DELETE_REQUEST })

  return Auth.currentSession()
    .then((session) => {
      const headerValue = `Bearer ${session.idToken.jwtToken}`

      return fetch(`${API_URL}/${service}/${id}`, {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'content-type': 'application/json',
          authorization: headerValue,
        },
        method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then((res) => res.json().then(data => { if (!res.ok) { return { notOk: true, ...data } } return data }))
        .then(
          (payload) => {
            if (   payload && payload.notOk) {
              dispatch({
                type: ActionType.Data.DELETE_FAILURE,
                payload,
                entityType: 'signup form',
              })
              return
            }

            dispatch({
              type: ActionType.SignupForm.DELETE_SUCCESS,
              id,
            })
          },
          (error) =>
            dispatch({
              type: ActionType.Data.DELETE_FAILURE,
              payload: error,
              entityType: 'signup form',
            }),
        )
    })
    .catch((err) => {
      console.log(err)
      if (err.code === 'UserNotFoundException') {
        window.localStorage.clear()
        window.location.reload(true)
      }
    })
}

export const getSignupFormSchema = (schemaType) => (dispatch, getState) => {
  dispatch({ type: ActionType.SignupForm.SCHEMA_REQUEST })

  const url = {
    POST: `${API_URL}/schema/${service}/${schemaType}/request/`,
    PUT: `${API_URL}/schema/${service}/signupformId/${schemaType}/request/`,
  }
  return new Promise((resolve, reject) => {
    return fetch(url[schemaType], {
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      headers: {
        'content-type': 'application/json',
        dnt: 0,
      },
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      redirect: 'follow', // manual, *follow, error
      referrer: 'no-referrer', // *client, no-referrer
    })
      .then((res) => res.json().then(data => { if (!res.ok) { return { notOk: true, ...data } } return data }))
      .then(
        (schema) => {
          dispatch({
            type: ActionType.SignupForm.SCHEMA_SUCCESS,
            payload: { schema, schemaType },
          })
          resolve(schema)
        },
        (error) => {
          dispatch({
            type: ActionType.SignupForm.SCHEMA_FAILURE,
            payload: error,
          })
          reject(error)
        },
      )
  })
}

export const receiveForm = (payload) => (dispatch, getState) =>
  dispatch({
    type: ActionType.SignupForm.RECEIVE_FORM,
    payload,
    groupsByID: groupsByID(getState()),
  })

export const toggleView = () => (dispatch) =>
  dispatch({ type: ActionType.SignupForm.TOGGLE_VIEW })

export const toggleSortMenu = (payload) => (dispatch) =>
  dispatch({ type: ActionType.SignupForm.TOGGLE_SORT_MENU })

export const toggleExpandPanel = (payload) => (dispatch) =>
  dispatch({ type: ActionType.SignupForm.TOGGLE_EXPAND_PANEL, payload })

export const changeSort = (payload) => (dispatch) =>
  dispatch({ type: ActionType.SignupForm.CHANGE_SORT, payload })
